import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import AddressBook from 'components/Admin/AddressBook';
// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        {/*<h1>Warehouse</h1>*/}
        <AddressBook />
      </SiteContent>
    </ContentLayout>
  );
};
